import { FlowComponentDefinition } from "../../interface/functionalityInterface";
import { OUTLINE_COLOR } from "./renderingUtils";

export const heatExchangerComponent: FlowComponentDefinition = {
  type: "heatExchanger",
  title: "heat exchanger",
  category: "Equipment",
  visualKind: "heatExchanger",
  defaultColor: "#9ea4ab",
  previewFlow: { from: "left", to: "right" },
  ports: ["left", "right", "up", "down"],
  incomingDirections: ["left", "up"],
  outgoingDirections: ["right", "down"],
  defaults: { productDiameter: "100", mediaDiameter: "80", duty: "250" },
  fields: [
    { key: "productDiameter", label: "Product dia." },
    { key: "mediaDiameter", label: "Media dia." },
    { key: "duty", label: "Duty" },
    { key: "color", label: "Color", inputType: "color" },
  ],
  renderGraphic: ({ isHeatExchangerVertical, arrowColor, pulseColor: _pulseColor }) =>
    isHeatExchangerVertical ? (
      <g transform="rotate(90 50 50)">
        <line x1="0" y1="50" x2="26" y2="50" stroke={OUTLINE_COLOR} strokeWidth="2.2" strokeLinecap="round" />
        <line x1="74" y1="50" x2="100" y2="50" stroke={OUTLINE_COLOR} strokeWidth="2.2" strokeLinecap="round" />
        <line x1="50" y1="0" x2="50" y2="26" stroke={OUTLINE_COLOR} strokeWidth="2.2" strokeLinecap="round" />
        <line x1="50" y1="74" x2="50" y2="100" stroke={OUTLINE_COLOR} strokeWidth="2.2" strokeLinecap="round" />
        <circle cx="50" cy="50" r="24" fill="#ffffff" stroke={OUTLINE_COLOR} strokeWidth="2.2" />
        <polyline
          points="41,39 62,39 49,50 62,61 41,61"
          fill="none"
          stroke={OUTLINE_COLOR}
          strokeWidth="2.2"
          strokeLinejoin="round"
          strokeLinecap="round"
        />
        <polygon points="18,50 30,44 30,56" fill={arrowColor} />
        <polygon points="50,82 44,70 56,70" fill={arrowColor} />
      </g>
    ) : (
      <>
        <line x1="0" y1="50" x2="26" y2="50" stroke={OUTLINE_COLOR} strokeWidth="2.2" strokeLinecap="round" />
        <line x1="74" y1="50" x2="100" y2="50" stroke={OUTLINE_COLOR} strokeWidth="2.2" strokeLinecap="round" />
        <line x1="50" y1="0" x2="50" y2="26" stroke={OUTLINE_COLOR} strokeWidth="2.2" strokeLinecap="round" />
        <line x1="50" y1="74" x2="50" y2="100" stroke={OUTLINE_COLOR} strokeWidth="2.2" strokeLinecap="round" />
        <circle cx="50" cy="50" r="24" fill="#ffffff" stroke={OUTLINE_COLOR} strokeWidth="2.2" />
        <polyline
          points="41,39 62,39 49,50 62,61 41,61"
          fill="none"
          stroke={OUTLINE_COLOR}
          strokeWidth="2.2"
          strokeLinejoin="round"
          strokeLinecap="round"
        />
        <polygon points="82,50 70,44 70,56" fill={arrowColor} />
        <polygon points="50,82 44,70 56,70" fill={arrowColor} />
      </>
    ),
  renderAnimatedFlow: ({ isHeatExchangerVertical, pulseColor }) =>
    isHeatExchangerVertical ? (
      <g transform="rotate(90 50 50)">
        <line x1="8" y1="50" x2="92" y2="50" stroke={pulseColor} strokeWidth="9" strokeLinecap="round" />
        <line x1="50" y1="8" x2="50" y2="92" stroke={pulseColor} strokeWidth="9" strokeLinecap="round" />
      </g>
    ) : (
      <>
        <line x1="8" y1="50" x2="92" y2="50" stroke={pulseColor} strokeWidth="9" strokeLinecap="round" />
        <line x1="50" y1="8" x2="50" y2="92" stroke={pulseColor} strokeWidth="9" strokeLinecap="round" />
      </>
    ),
};
